import { render, staticRenderFns } from "./CertificatesComponent.vue?vue&type=template&id=5786b435&scoped=true&"
import script from "./CertificatesComponent.vue?vue&type=script&lang=js&"
export * from "./CertificatesComponent.vue?vue&type=script&lang=js&"
import style0 from "./CertificatesComponent.vue?vue&type=style&index=0&id=5786b435&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5786b435",
  null
  
)

export default component.exports